import { Grid } from "@mui/material";
import ByAssigneeDashboard from "./ByAssigneeDashboard";
import ByStatusDashboard from "./ByStatusDashboard";
import DashboardProvider from "./DashboardContext";

let Index = () => {
    return (
        <DashboardProvider>
            <Grid container>
                <Grid item lg md sm={12} xs={12}><ByStatusDashboard /></Grid>
                <Grid item lg md sm={12} xs={12}><ByAssigneeDashboard /></Grid>
            </Grid>
        </DashboardProvider>
    );
}


export default Index;